import React from 'react'
import useStyles from './ReportsModalBody.styles'
import {Box} from '@material-ui/core'

type Props = {
  children: React.ReactNode
  width?: number | string
}

function ReportsModalBody(props: Props) {
  const {width, children} = props
  const classes = useStyles()

  return (
    <Box width={width} className={`${classes.root} ReportsModalBody`}>
      {children}
    </Box>
  )
}

export default ReportsModalBody
